import React from "react";
import { IndexedCardInfo } from "@akj-dev/shared-components";
import { ChooseHardwareTableContainer } from "./containers/Table";

export const ChooseHardware = () => (
  <IndexedCardInfo index={1} title="Please select required hardware">
    <ChooseHardwareTableContainer />
  </IndexedCardInfo>
);
